<template>
  <div v-if="data">
    <h2 class="text-black mb-3 pt-4">
      Tellimer Events <small class="text-muted">(optional)</small>
    </h2>

    <div
      v-for="(event, j) in data"
      :key="`event-${j}`"
    >
      <div class="form-group">
        <label>Event {{ j + 1 }} Date</label>

        <flat-pickr
          v-model="event.date"
          placeholder="Pick a Date"
        />
      </div>


      <form-control
        v-model="event.title"
        :title="`Event ${j + 1} Title`"
        :placeholder="`Enter Event ${j + 1} title`"
      />

      <form-control
        v-model="event.location"
        :title="`Event ${j + 1} Location`"
        :placeholder="`Enter Event ${j + 1} location`"
        optional
        class="my-3"
      />

      <label>Event {{ j + 1 }} Description <span class="text-muted">(optional)</span></label>
      <HtmlEditor
        v-model="event.description"
        :token="`Bearer ${$login.getToken()}`"
        :image-upload-url="imageUploadUrl"
        :file-upload-url="fileUploadUrl"
      />
    </div>

    <div class="form-group border-bottom pb-5 mb-3 mt-4">
      <button
        @click="addEvent"
        type="button"
        class="btn btn-outline-secondary btn-block text-black"
      >
        Add Event
      </button>
    </div>
  </div>
</template>

<script>
import {HtmlEditor} from '@frontend/components'

export default {
  components: {
    HtmlEditor,
  },

  props: {
    value: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    data: null,
    error: null,
    imageUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/image',
    fileUploadUrl: process.env.VUE_APP_API_ENDPOINT + 'upload/file'
}),

mounted () {
  this.data = this.value
  },

  watch: {
    data () {
      this.$emit('input', this.data)
    },

    value () {
      this.data = this.value
    },
  },

  methods: {
    addEvent () {
      this.data.push({date: '', title: '', description: '', location: ''})
    },

  },
}
</script>
